import config from 'message-control/config'

const ewechatMsgApi = `${config.apiHost}/oem-ewechat_msg`

export default {
    // 单聊
    chatList: {
        url: `${ewechatMsgApi}/api/query/msg`,
        type: 'GET',
    },
    // 群聊
    groupChatList: {
        url: `${ewechatMsgApi}/api/room_msg/room/query`,
        type: 'GET',
    },
}
